module.exports = __webpack_public_path__ + "assets/CentroidOfQuadrilateralDetailed.381006421de9d291d326e0bbcb032b42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/CentroidOfQuadrilateralDetailed.png
// module id = 478
// module chunks = 0